import { render, staticRenderFns } from "./GeneralCargoPerformance.vue?vue&type=template&id=073e204a&scoped=true&"
import script from "./GeneralCargoPerformance.vue?vue&type=script&lang=js&"
export * from "./GeneralCargoPerformance.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCargoPerformance.vue?vue&type=style&index=0&id=073e204a&lang=scss&scoped=true&"
import style1 from "./GeneralCargoPerformance.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e204a",
  null
  
)

export default component.exports